import React, { Component } from 'react';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { FormattedMessage, injectIntl } from "react-intl";
import NewsletterSubscription
    from "../../components/portfolio/BlogPage/NewsletterSubscription";
import { formatPhone } from '../../helpers/format';
import { toast } from 'react-toastify';
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'
import { HtmlTagSchemaMarkup } from '../../components/SEO/HtmlTagSchemaMarkup'
import { contactPoint } from '../../components/SEO/Organization'
import { cleanupTelephone } from '../../helpers/string'

class FormContact extends Component {
    state = {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        subject: '',
        content: '',
        conditions_accepted: false
    };

    submit(e) {

        e.preventDefault();

        const {
            firstname,
            lastname,
            phone,
            email,
            subject,
            content
        } = this.state;
        const { intl } = this.props;
        this.setState({ loading: true });

        Request.post('contact/submit', {
            firstname, lastname, phone, email, subject, content
        })
            .then(() => {

                toast.success(
                    intl.formatMessage({
                        id: "portfolio.form_contact.message_sent",
                        defaultMessage: "Votre message a bien été envoyé."
                    })
                );
                this.setState({ loading: false });
                this.props.history.push(addLocalePrefix('/'));
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({ loading: true });
            });
    }

    toggleConditionsAccepted() {
        this.setState({ conditions_accepted: !this.state.conditions_accepted });
    }

    render() {
        const { intl } = this.props;

        return (
            <div className="form-contact-page">

                <MetaTags page="contact" />
                <HtmlTagSchemaMarkup type="ContactPage" />

                <section className="contact-form">
                    <Container>
                        <div className="form-head">
                            <h1 className="line-heading">
                                <FormattedMessage
                                    id="portfolio.form_contact.title"
                                    defaultMessage="ON SE TIENT AU JUS&nbsp;?"
                                />
                            </h1>
                            <p>
                                <FormattedMessage
                                    id="portfolio.form_contact.subtitle1"
                                    defaultMessage="Notre système de contact par télépathie est en panne pour le moment."
                                />
                                <br />
                                <FormattedMessage
                                    id="portfolio.form_contact.subtitle2"
                                    defaultMessage="En attendant, remplissez le formulaire ci-dessous et nous reviendrons vers vous dans les 48h !"
                                />
                            </p>
                        </div>
                        <div className="contact-form-wrap">
                            <Form onSubmit={(e) => this.submit(e)}>
                                <div className="fields-row">
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_contact.firstname.label"
                                                defaultMessage="Prénom*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            onChange={(e) => this.setState({ firstname: e.target.value })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_contact.firstname.placeholder",
                                                    defaultMessage: "Pierre"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_contact.lastname.label"
                                                defaultMessage="Nom*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            onChange={(e) => this.setState({ lastname: e.target.value })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_contact.lastname.placeholder",
                                                    defaultMessage: "Durand"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_contact.phone.label"
                                                defaultMessage="Téléphone*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="tel"
                                            pattern="([+]?[0-9]+)?"
                                            className="input-field"
                                            onChange={(e) => this.setState({ phone: formatPhone(e) })}
                                            value={this.state.phone}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_contact.phone.placeholder",
                                                    defaultMessage: "Format : (+33)0123456789"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_contact.email.label"
                                                defaultMessage="Email*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="email"
                                            className="input-field"
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_contact.email.placeholder",
                                                    defaultMessage: "Pour vous écrire"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                </div>

                                <div className="msg-fields-row">
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_contact.subject.label"
                                                defaultMessage="Objet du message*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            onChange={(e) => this.setState({ subject: e.target.value })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_contact.subject.placeholder",
                                                    defaultMessage: "De quoi voulez-vous nous parler ?"
                                                })
                                            }

                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_contact.message.label"
                                                defaultMessage="Message*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            onChange={(e) => this.setState({ content: e.target.value })}
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_contact.message.placeholder",
                                                    defaultMessage: "Expliquez-nous votre démarche"
                                                })
                                            }
                                        />
                                    </FormGroup>
                                </div>

                                <div className="btn-wrap checkbox-wrap">
                                    <div
                                        className="custom-control checkbox-wrap mb-5 warning">
                                        <Input
                                            required
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="posibility"
                                            onChange={() => this.toggleConditionsAccepted()}
                                        />
                                        <Label className="custom-control-label"
                                               htmlFor="posibility">
                                            <span className="box-block mr-3" />
                                            <span className="check-text">
                                            <FormattedMessage
                                                id="portfolio.form.cgu"
                                                defaultMessage="En cochant la case, vous confirmez avoir lu et accepté les conditions d'utilisation de vos données listées {link}."
                                                values={{
                                                    link: (
                                                        <LocaleLink to={'/cgu'}
                                                                    className={'link-cgu'}
                                                                    target='_blank'>
                                                            <FormattedMessage
                                                                id="myurban.header.notifications.new_application_to_job_order.here"
                                                                defaultMessage={'ici'}
                                                            />
                                                        </LocaleLink>
                                                    )
                                                }} />
                                            </span>
                                        </Label>
                                    </div>
                                    <Button
                                        className="btn btn-warning"
                                        disabled={this.state.loading}
                                    >
                                        <FormattedMessage
                                            id="portfolio.form_contact.button"
                                            defaultMessage="ENVOYER"
                                        />
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                </section>

                <section className="contact-details">
                    <div className="container">
                        <div className="contant-wrap">
                            <div className="contact-inner">
                                <div className="contact-primary">
                                    <div className="contact-block">
                                        <h3>BORDEAUX</h3>
                                        <address>
                                            <span>
                                                {contactPoint.bordeaux.streetAddress}<br />
                                                {contactPoint.bordeaux.postalCode} {contactPoint.bordeaux.addressLocality}
                                            </span>
                                            <span>
                                                <a className="tel"
                                                   href={`tel:${cleanupTelephone(contactPoint.bordeaux.telephone)}`}>
                                                    {contactPoint.bordeaux.telephone}
                                                </a>
                                            </span>
                                            <span>
                                                <a className="color-warning"
                                                   href={`mailto:${contactPoint.bordeaux.email}`}>
                                                    {contactPoint.bordeaux.email}
                                                </a>
                                            </span>
                                        </address>
                                    </div>
                                    <div className="contact-block">
                                        <h3>PARIS</h3>
                                        <address>
                                            <span>
                                                {contactPoint.paris.streetAddress}<br />
                                                {contactPoint.paris.postalCode} {contactPoint.paris.addressLocality}
                                            </span>
                                            <span>
                                                <a className="tel"
                                                   href={`tel:${cleanupTelephone(contactPoint.paris.telephone)}`}>
                                                    {contactPoint.paris.telephone}
                                                </a>
                                            </span>
                                            <span>
                                                <a className="color-warning"
                                                   href={`mailto:${contactPoint.paris.email}`}>
                                                    {contactPoint.paris.email}
                                                </a>
                                            </span>
                                        </address>
                                    </div>
                                    <div className="contact-block">
                                        <h3>LYON & REGIONS</h3>
                                        <address>
                                            <span>
                                                {contactPoint.lyon.streetAddress}<br />
                                                {contactPoint.lyon.postalCode} {contactPoint.lyon.addressLocality}
                                            </span>
                                            <span>
                                                <a className="tel"
                                                   href={`tel:${cleanupTelephone(contactPoint.lyon.telephone)}`}>
                                                    {contactPoint.lyon.telephone}
                                                </a>
                                            </span>
                                            <span>
                                                <a className="color-warning"
                                                   href={`mailto:${contactPoint.lyon.email}`}>
                                                    {contactPoint.lyon.email}
                                                </a>
                                            </span>
                                        </address>
                                    </div>
                                </div>

                                <NewsletterSubscription />

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default injectIntl(FormContact);
